import { FiCommentSettingType } from '@fi-shared/types';

interface IMediaBankFileSetting {
    IsNews: boolean;
    SendPushMessages: boolean;
    CommentSettingType: FiCommentSettingType;
}

export class MediaBankFileSetting {
    IsNews: boolean = true; // FI_CUSTOMER_DATA.CanShareAsNews;
    SendPushMessages: boolean = true;
    CommentSettingType: FiCommentSettingType = FiCommentSettingType.NoComments;

    Initialize(mediaBankFileSetting: IMediaBankFileSetting) {
        this.IsNews = mediaBankFileSetting.IsNews;
        this.SendPushMessages = mediaBankFileSetting.SendPushMessages;
        if (mediaBankFileSetting.CommentSettingType) {
            this.CommentSettingType = mediaBankFileSetting.CommentSettingType;
        }
    }
}
